import React, { Suspense, lazy } from 'react';
import { IntlProvider } from 'react-intl';
import { Route, Routes } from "react-router-dom";

import ProtectedRoutes from './components/ProtectedRoute';
import Layout from './pages/Layout';
import Login from './pages/Login';
import './style/App.scss';

const RegPatient = lazy(() => import('./pages/PatientRegistration'));
const CardiacPage = lazy(() => import('./pages/Cardiac'));
const DiabatesPage = lazy(() => import('./pages/Diabetes'));
const BreastCancer = lazy(() => import('./pages/BreastCancer'));
const Opthalmology = lazy(() => import('./pages/Opthalmology'));
const PatientRecordLayout = lazy(() => import('./pages/PatientRecordLayout'));
const NotFound = lazy(() => import('./pages/NotFound'));
const Signup = lazy(() => import('./pages/Signup'));

function App() {
  // const [locale, setLocale] = useState('en');

  return (
    <IntlProvider>
      <Suspense fallback={<div />}>
          <Routes>
            <Route path="/" element={<ProtectedRoutes Component={Layout} />} />
            <Route path="/patientRegister" element={<ProtectedRoutes Component={RegPatient} />} />
            <Route path="/cardiac" element={<ProtectedRoutes Component={CardiacPage} />} />
            <Route path="/diabetes" element={<ProtectedRoutes Component={DiabatesPage} />} />
            <Route path="/breastcancer" element={<ProtectedRoutes Component={BreastCancer} />} />
            <Route path="/opthal" element={<ProtectedRoutes Component={Opthalmology} />} />
            <Route path="/patientRecord" element={<ProtectedRoutes Component={PatientRecordLayout} />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
      </Suspense>
    </IntlProvider>
  );
}

export default App;